﻿export const start = {
    text: 'Granska din ansökan om sparande som är bifogad som PDF nedan. Om allt stämmer signerar du din ansökan med BankID för att starta sparandet.',
    headline: 'Din ansökan är godkänd och kan signeras',
    disclaimer: 'Tryck på knappen för att påbörja din ansökan.',
    buttonText: 'Signera med BankID'
}

export const final = {
    headline: 'Allt är klart!',
    text: 'Du har nu signerat din ansökan. Du kommer att få en bekräftelse på den tecknade försäkringen och  ditt försäkringsbesked på Mina sidor hos Futur Pension.',
    paragraph2: 'Din ansökan med de svar du lämnat finns tillgänglig under Mina dokument på Lärarförsäkringars Mina sidor.',
    buttonText: 'Låter bra! Avsluta guiden.'
}

export const loader = {
    text: 'Starta BankID-appen i din telefon för att signera din ansökan.'
}

export const scanQr = {
    headline: 'Signera din ansökan',
    text: 'Starta BankID-appen på din mobila enhet och läs av QR-koden för att signera din ansökan'
}

export const selectMethod = {
    headline: 'Signera din ansökan',
    text: 'Välj hur du vill signera din ansökan'
}

export const openApp = {
    headline: 'Signera din ansökan',
    text: 'Starta BankID-appen på denna enhet för att signera din ansökan'
}

export const error = {
    headline: 'Signeringen avbröts',
    text: 'Signeringen slutfördes inte eftersom det tog för lång tid.',
    buttonText: 'Signera på nytt'
}

export const redirects = {
    start: 'https://www.lararforsakringar.se/'
}

export const URLS = {
    start: '/',
    selectMethod: '/select-method',
    scanQr: '/scan-qr',
    openDesktopApp: '/open-desktop-app',
    openMobileApp: '/open-mobile-app',
    resultSuccess: '/result-success',
    resultFailed: '/result-failed'
};
